export default __webpack_public_path__ + "static/media/ActivityActivity-documentation.5456691d.md";